define([
    'jed/jed',
    'app/lang/sv_SE/messages',
    'app/lang/nb_NO/messages',
    'app/lang/da_DK/messages',
    'app/lang/fi_FI/messages',
], function (Jed, locale_se, locale_no, locale_dk, locale_fi) {
    var locale = false;
    var translator = false;
    var addedTranslations = [];

    if (partyking.config.country == 'NO') {
        locale = locale_no;
    } else if (partyking.config.country == 'DK') {
        locale = locale_dk;
    } else if (partyking.config.country == 'FI') {
        locale = locale_fi;
    } else {
        locale = locale_se;
    }

    try {
        translator = new Jed({
            locale_data: locale.locale_data,
            domain: 'messages',
            missing_key_callback: function (key) {
                if (
                    (_.has(locale_se.locale_data.messages, key) &&
                        partyking.office == 1 &&
                        addedTranslations.indexOf(key) == -1) ||
                    (partyking.config.country == 'SE' &&
                        partyking.office == 1 &&
                        addedTranslations.indexOf(key) == -1)
                ) {
                    $.post(
                        '/translate/token',
                        { token: key },
                        function (result) {
                            addedTranslations.push(key);
                        }
                    );
                }
            },
        });
    } catch (e) {
        console.error('messages failed :(');

        /* Bugsnag.notify("MESSAGES.JS BROKEN!!", e); */

        translator = {
            translate: function (text) {
                return {
                    fetch: function () {
                        return text;
                    },
                };
            },
        };
    }
    return translator;
});
